import Vue from 'vue'
import Router from 'vue-router'

// 公共类页面
import mainPage from '@/views/Main'
// import page404 from '@/views/Page404'

// 模块页面
import homePage from '@/views/Home'
import productPage from '@/views/Product'
import solutionPage from '@/views/Solution'
import consultPage from '@/views/Consult'
import unionPage from '@/views/Union'
import aboutPage from '@/views/About'

// 智慧物联组件
import envMonitorPage from '@/components/solution/IotEnvMonitor'
import riverMonitorPage from '@/components/solution/IotRiverMonitor'
import farmMonitorPage from '@/components/solution/IotFarmMonitor'
import industryMonitorPage from '@/components/solution/IotIndustryMonitor'

// 防伪溯源组件
import seedTracePage from '@/components/trace/SeedTrace'
import foodTracePage from '@/components/trace/FoodTrace'
import drinkTracePage from '@/components/trace/DrinkTrace'
import materialTracePage from '@/components/trace/MaterialTrace'
import otherTracePage from '@/components/trace/OtherTrace'

// 社区服务组件
import idleAssetPage from '@/components/community/IdleAsset'
import houseKeepPage from '@/components/community/HouseKeep'
import deliveryPage from '@/components/community/Delivery'
import helpEachPage from '@/components/community/HelpEach'

// 产品服务组件
import networkDevicePage from '@/components/product/NetworkDevice'
import collectDevicePage from '@/components/product/CollectDevice'
import relateSystemPage from '@/components/product/RelateSystem'
import relatePDAPage from '@/components/product/RelatePDA'
import storePDAPage from '@/components/product/StorePDA'
import tracePlatformPage from '@/components/product/TracePlatform'
import storePCPage from '@/components/product/StorePC'

// 咨询服务组件
import traceConsultPage from '@/components/consult/TraceConsult'
import envConsultPage from '@/components/consult/EnvConsult'
import farmConsultPage from '@/components/consult/FarmConsult'
import collectConsultPage from '@/components/consult/CollectConsult'
import infoConsultPage from '@/components/consult/InfoConsult'

// 公司介绍组件
import introducePage from '@/components/about/Introduce'
import qualificationPage from '@/components/about/Qualification'
import eventsPage from '@/components/about/Events'
import partnerPage from '@/components/about/Partner'
import joinUsPage from '@/components/about/JoinUs'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'mainPage',
      component: mainPage,
      children: [
        {
          path: '/',
          redirect: {
            name: 'home'
          }
        },
        {
          path: '/home',
          name: 'home',
          component: homePage
        },
        {
          path: '/solution',
          name: 'solution',
          component: solutionPage,
          redirect: '/solution/seedTrace',
          children: [
            {
              path: '/solution/envMonitor',
              name: 'envMonitor',
              component: envMonitorPage
            },
            {
              path: '/solution/riverMonitor',
              name: 'riverMonitor',
              component: riverMonitorPage
            },
            {
              path: '/solution/farmMonitor',
              name: 'farmMonitor',
              component: farmMonitorPage
            },
            {
              path: '/solution/industryMonitor',
              name: 'industryMonitor',
              component: industryMonitorPage
            },
            {
              path: '/solution/seedTrace',
              name: 'seedTrace',
              component: seedTracePage
            },
            {
              path: '/solution/foodTrace',
              name: 'foodTrace',
              component: foodTracePage
            },
            {
              path: '/solution/drinkTrace',
              name: 'drinkTrace',
              component: drinkTracePage
            },
            {
              path: '/solution/materialTrace',
              name: 'materialTrace',
              component: materialTracePage
            },
            {
              path: '/solution/otherTrace',
              name: 'otherTrace',
              component: otherTracePage
            },
            {
              path: '/solution/idleAsset',
              name: 'idleAsset',
              component: idleAssetPage
            },
            {
              path: '/solution/houseKeep',
              name: 'houseKeep',
              component: houseKeepPage
            },
            {
              path: '/solution/delivery',
              name: 'delivery',
              component: deliveryPage
            },
            {
              path: '/solution/helpEach',
              name: 'helpEach',
              component: helpEachPage
            }
          ]
        },
        {
          path: '/product',
          name: 'product',
          component: productPage,
          redirect: '/product/networkDevice',
          children: [
            {
              path: '/product/networkDevice',
              name: 'networkDevice',
              component: networkDevicePage
            },
            {
              path: '/product/collectDevice',
              name: 'collectDevice',
              component: collectDevicePage
            },
            {
              path: '/product/relateSystem',
              name: 'relateSystem',
              component: relateSystemPage
            },
            {
              path: '/product/relatePDA',
              name: 'relatePDA',
              component: relatePDAPage
            },
            {
              path: '/product/storePDA',
              name: 'storePDA',
              component: storePDAPage
            },
            {
              path: '/product/tracePlatform',
              name: 'tracePlatform',
              component: tracePlatformPage
            },
            {
              path: '/product/storePC',
              name: 'storePC',
              component: storePCPage
            }
          ]
        },
        {
          path: '/consult',
          name: 'consult',
          component: consultPage,
          redirect: '/solution/traceConsult',
          children: [
            {
              path: '/solution/traceConsult',
              name: 'traceConsult',
              component: traceConsultPage
            },
            {
              path: '/solution/envConsult',
              name: 'envConsult',
              component: envConsultPage
            },
            {
              path: '/solution/farmConsult',
              name: 'farmConsult',
              component: farmConsultPage
            },
            {
              path: '/solution/collectConsult',
              name: 'collectConsult',
              component: collectConsultPage
            },
            {
              path: '/solution/infoConsult',
              name: 'infoConsult',
              component: infoConsultPage
            }
          ]
        },
        {
          path: '/union',
          name: 'union',
          component: unionPage
        },
        {
          path: '/about',
          name: 'about',
          component: aboutPage,
          redirect: '/about/introduce',
          children: [
            {
              path: '/about/introduce',
              name: 'introduce',
              component: introducePage
            },
            {
              path: '/about/qualification',
              name: 'qualification',
              component: qualificationPage
            },
            {
              path: '/about/events',
              name: 'events',
              component: eventsPage
            },
            {
              path: '/about/partner',
              name: 'partner',
              component: partnerPage
            },
            {
              path: '/about/joinUs',
              name: 'joinUs',
              component: joinUsPage
            }
          ]
        }
      ]
    }
  ]
})
